import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { withTranslation } from "react-i18next";
import styles from "./AdminUsers.scss";

class ShowAdminUsers extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { adminUsers } = this.props;
    return (
        <React.Fragment>
            <h2 className='u-mb15'>事務局ユーザー一覧</h2>
            <article className='admin-user-list'>
              <header>
                <div className='admin-user-id'>Id</div>
                <div className='admin-user-email'>Email</div>
                <div className='admin-user-permission'>Permission</div>
              </header>
              {adminUsers.map((adminUser, index) => {
                return (
                  <section key={index}>
                    <div className='admin-user-id'>{adminUser.id}</div>
                    <div className='admin-user-email'>{adminUser.email}</div>
                    <div className='admin-user-permission'>{adminUser.permission}</div>
                    <div className="admin-user-controls">
                      <a href={`/desk/admin_users/${index+1}`} className='btn btn-secondary btn-sm'>Details</a>
                    </div>
                  </section>
                )})
              }
            </article>
        </React.Fragment>
    );
  }
}

export default connect()(withTranslation()(ShowAdminUsers));
